// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



import Modal from 'components/Modal'

import PropTypes from 'prop-types'

import 'styles/components/settings/inboxes/HelpModal.styl'

const joinHelpLinks = links =>
  _.transform(links, function(result, provider, i) {
    result.push(<a href={provider.link} target="_blank">
      {provider.display}
    </a>)

    if (i !== (links.length - 1)) {
      return result.push(<span>
        {', '}
      </span>)
    } else {
      return result.push(<span>
        .
      </span>)
    }
  })


const forwardingHelpLinks = [
  {
    display: 'Gmail',
    link: 'https://support.google.com/mail/answer/10957?hl=en'
  },
  {
    display: 'GoDaddy',
    link: 'https://www.godaddy.com/help/managing-email-forwarding-3367'
  },
  {
    display: 'Office 365',
    link: 'https://technet.microsoft.com/en-us/library/dd351134(v=exchg.141).aspx'
  }
]

const dkimHelpLinks = [
  {
    display: 'Godaddy',
    link: 'https://www.godaddy.com/help/add-a-cname-record-19236'
  },
  {
    display: 'Rackspace',
    link: 'http://www.rackspace.com/knowledge_center/article/creating-dns-records-for-cloud-servers-with-the-control-panel#D'
  },
  {
    display: 'Hostgator',
    link: 'http://support.hostgator.com/articles/hosting-guide/lets-get-started/dns-name-servers/manage-dns-records-with-hostgatorenom'
  },
  {
    display: 'Dreamhost',
    link: 'http://wiki.dreamhost.com/CNAME_record#Custom_CNAME_Record'
  },
  {
    display: 'AWS',
    link: 'http://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/CNAMEs.html'
  }
]

const HelpModal = React.createClass({
  propTypes: {
    onClose: PropTypes.func,
    type: PropTypes.string,
    inbox: PropTypes.object
  },

  getForwardingHelpLinks() { return joinHelpLinks(forwardingHelpLinks) },

  getDKIMHelpLinks() { return joinHelpLinks(dkimHelpLinks) },

  getModalHeader() {
    if (this.props.type === 'forward') { return 'Email Forwarding' } else { return 'White Label (DKIM)' }
  },

  getModalContent() {
    if (this.props.type === 'forward') {
      return (
        <div className="set-up-steps">
          Email forwarding must be configured from your current email provider’s website.
          <div className="link-text">
            {'Here are some links that you might find useful: '}
          </div>
          {this.getForwardingHelpLinks()}
        </div>
      )
    } else {
      return (
        <div className="set-up-steps">
          {'DKIM must be configured in order for us to send email on behalf of '}
          <span>
            {this.props.inbox.address}
          </span>
          <div className="link-text">
            {'Here are some links that you might find useful: '}
          </div>
          {this.getDKIMHelpLinks()}
        </div>
      )
    }
  },

  render() {
    return (
      <div className="HelpModal">
        <Modal onClose={this.props.onClose}>
          <div className="title">
            {this.getModalHeader()}
          </div>
          <div className="set-up">
            {this.getModalContent()}
            <div>
              {'Having trouble? Contact us at: '}
              <a href="mailto:support@driftt.com">
                support@driftt.com
              </a>
            </div>
          </div>
          <div>
            <div className="bottom-divider" />
            <div className="button-container">
              <button className="color-teal btn-settings" onClick={this.props.onClose}>
                got it
              </button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
})

export default HelpModal



// WEBPACK FOOTER //
// ./src/scripts/components/settings/inboxes/HelpModal.js